module.exports = __webpack_public_path__ + "static/phone@2x-64c726215d26dae060f36892984162e6.png";